window.CreatePostV2 = new function () {
    this.vars = {
        token: jQuery('meta[name="csrf-token"]').attr('content')
    };

    this.init = function () {
        PostImages.init('create-edit-post-v2-form', 'images/funnews/posts');

        jQuery('#post-create-v2-modal').on('shown.bs.modal', function (e) {
            jQuery('#post-create-v2-modal select.select-search-in-modal:not(.select2-hidden-accessible)').select2();
        });

        //Click Save Draft
        jQuery('.create-edit-post-v2-form button.save-draft').click(function (event) {
            jQuery('.create-edit-post-v2-form input[name="status"]').val(2);
        });

        jQuery('body').on('submit', '.create-edit-post-v2-form', function (event) {
            if (jQuery('body').hasClass('cropping')) {
                event.preventDefault();
                return false;
            }
            
            const $form = jQuery(this);
            const $submitBtn = $form.find(':submit');

            if ($submitBtn.prop('disabled')) {
                return; // Already submitted
            }

            $submitBtn.prop('disabled', true);

            jQuery('.create-edit-post-v2-form .image-repeater .field').each(function (index, el) {
                if (!jQuery(el).find('.img-container').length) {
                    jQuery(el).remove();
                }
            });

            if (
                jQuery('.create-edit-post-v2-form input[name="post_has"]').val() == 'image' &&
                !jQuery('.create-edit-post-v2-form #image-input')[0].files.length
            ) {
                jQuery('.create-edit-post-v2-form input[name="post_has"]').val('');
            }

            if (jQuery('.create-edit-post-v2-form input[name="post_has"]').val() == 'video') {
                event.preventDefault();
                VideoUploader.uploadVideo('form.create-edit-post-v2-form', '#video', 'videos/funnews/posts');
            }
        });

        jQuery('body').on('click', '.create-edit-post-v2-form #post_type_tabs .tab', function (event) {
            var tab_name = jQuery(this).data('tab-name');

            jQuery('.create-edit-post-v2-form input[name="post_type"]').val(tab_name);
            jQuery('.create-edit-post-v2-form .preview-post').attr('href', '/posts/preview?post_type=' + tab_name + '&spoiler=false');

            if (tab_name == 'text') {
                jQuery('.create-edit-post-v2-form textarea[name="headline_content"]').prop('required', true);
                jQuery('.create-edit-post-v2-form textarea[name="headline_content"]').prop('disabled', false);

                jQuery('.create-edit-post-v2-form input[name="name"]').prop('required', false);
                jQuery('.create-edit-post-v2-form input[name="name"]').prop('disabled', true);
                jQuery('.create-edit-post-v2-form .choose-post-type[data-type="link"]').show();
            } else {
                jQuery('.create-edit-post-v2-form textarea[name="headline_content"]').prop('required', false);
                jQuery('.create-edit-post-v2-form textarea[name="headline_content"]').prop('disabled', true);

                jQuery('.create-edit-post-v2-form input[name="name"]').prop('disabled', false);
                jQuery('.create-edit-post-v2-form input[name="name"]').prop('required', true);
                jQuery('.create-edit-post-v2-form .choose-post-type[data-type="link"]').hide();
            }
        });

        jQuery('body').on('click', '.create-edit-post-v2-form .repeater-field .row-actions .remove', function (event) {
            jQuery('.create-edit-post-v2-form .image-repeater .field').each(function (index, el) {
                if (!jQuery(el).find('.img-container').length) {
                    jQuery(el).remove();
                }
            });

            if (
                jQuery('.create-edit-post-v2-form input[name="post_has"]').val() == 'image' &&
                !jQuery('.create-edit-post-v2-form .image-repeater .field').length
            ) {
                jQuery('.create-edit-post-v2-form input[name="post_has"]').val('');
            }
        });

        jQuery('body').on('click', '.create-edit-post-v2-form .choose-post-type:not(.disabled)', function (event) {
            event.preventDefault();
            jQuery('.create-edit-post-v2-form .post-type-picker .choose-post-type').addClass('disabled');
            jQuery('.create-edit-post-v2-form .post-type-container').removeClass('active');
            jQuery(this).addClass('active').removeClass('disabled');

            var post_type = jQuery(this).data('type');

            if (post_type == 'image') {
                CreatePostV2.addImage();
            } else if (post_type == 'video') {
                CreatePostV2.addVideo();
            } else if (post_type == 'link') {
                CreatePostV2.setPostTypeLink();
            } else if (post_type == 'poll') {
                CreatePostV2.addPoll();
            }
        });

        jQuery('body').on('click', '.create-edit-post-v2-form .remove-video, .create-edit-post-v2-form .clear-link', function (event) {
            CreatePostV2.resetPostType();
        });

        jQuery('body').on('click', '.create-edit-post-v2-form .remove-video, .create-edit-post-v2-form .clear-poll', function (event) {
            CreatePostV2.resetPostType();
        });

        jQuery('body').on('change', '.create-edit-post-v2-form input[name="external_url"]', function (event) {
            jQuery('.video-shell, .external-shell').hide();

            var url = jQuery(this).val();
            if (url) {
                if (url.includes('youtube')) {
                    try {
                        url = new URL(jQuery(this).val());
                        jQuery('.create-edit-post-v2-form #video-iframe').attr('src', url.href.replace("/watch?v=", "/embed/"));
                        jQuery('.video-shell').show();
                    } catch (_) {
                        return;
                    }
                } else if (url.includes('youtu.be')) {
                    var youtube_id = CreatePostV2.getYouTubeId(url);
                    url = new URL('https://www.youtube.com/watch?v=' + youtube_id);
                    jQuery('.create-edit-post-v2-form input[name="external_url"]').val(url);
                    jQuery('.create-edit-post-v2-form #video-iframe').attr('src', url.href.replace("/watch?v=", "/embed/"));
                    jQuery('.video-shell').show();
                } else {
                    CreatePostV2.scrapeExternalUrl(url);
                }
            }
        });
    };

    /**
     * Activate image fields
     */
    this.addImage = function () {
        jQuery('.create-edit-post-v2-form input[name="post_has"]').val('image');
        jQuery('.create-edit-post-v2-form .post-type-container[data-type="image"]').addClass('active');
        jQuery('.create-edit-post-v2-form .post-type-container[data-type="image"] input#image-input').click();
    };

    /**
     * Activate video fields
     */
    this.addVideo = function () {
        jQuery('.create-edit-post-v2-form input[name="post_has"]').val('video');
        jQuery('.create-edit-post-v2-form .post-type-container[data-type="video"]').addClass('active');
        jQuery('.create-edit-post-v2-form .post-type-container[data-type="video"] .add-video').click();
    };

    /**
     * Activate link fields
     */
    this.setPostTypeLink = function () {
        jQuery('.create-edit-post-v2-form input[name="post_type"]').val('link');
        jQuery('.create-edit-post-v2-form .tab-bar').hide();
        jQuery('.create-edit-post-v2-form .preview-post').attr('href', '/posts/preview?post_type=link&spoiler=false');

        jQuery('.create-edit-post-v2-form .post-type-container[data-type="link"]').addClass('active');
    };

    /**
     * Activate poll fields
     */
    this.addPoll = function () {
        jQuery('.create-edit-post-v2-form input[name="post_has"]').val('poll');
        jQuery('.create-edit-post-v2-form .post-type-container[data-type="poll"]').addClass('active');

        jQuery('.create-edit-post-v2-form .poll-create input[data-required="true"]').prop('required', true);
    };

    /**
     * Reset form to plain text post
     */
    this.resetPostType = function () {
        jQuery('.create-edit-post-v2-form .tab-bar').show();
        jQuery('.create-edit-post-v2-form input[name="post_has"]').val('');
        jQuery('.create-edit-post-v2-form .poll-create input[data-required="true"]').prop('required', false);

        var post_type = jQuery('.create-edit-post-v2-form .tab-bar .tab.active').data('tab-name');
        jQuery('.create-edit-post-v2-form input[name="post_type"]').val(post_type);

        jQuery('.create-edit-post-v2-form .post-type-container').removeClass('active');
        jQuery('.create-edit-post-v2-form .post-type-picker .choose-post-type').removeClass('disabled').removeClass('active');

        jQuery('.create-edit-post-v2-form #repeaterImages').empty();
        var repeater_field = jQuery('.create-edit-post-v2-form').find('.image-repeater .repeater-field');
        var backup_row = jQuery(repeater_field).attr('data-backup-row');
        var backup_row_html = jQuery('.' + backup_row).html();

        jQuery(repeater_field).find('.fields').append(backup_row_html);
    };

    /**
     * Get youtube ID from a youtu.be url
     *
     * @param string url
     * @return string
     */
    this.getYouTubeId = function (url) {
        var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
        var match = url.match(regExp);
        return (match && match[7].length == 11) ? match[7] : false;
    };

    /**
     * Scrape external site to retrieve title and description
     * 
     * @param string url
     */
    this.scrapeExternalUrl = function (url) {
        $.ajax({
            url: '/posts/externalurl',
            type: 'POST',
            data: {
                url: url,
                _token: CreatePostV2.vars.token
            },
            showloader: true,
            success: function (response) {
                var meta_data = JSON.parse(response);

                try {
                    var domain = (new URL(url));
                    var hostname = domain.hostname.replace('www.', '');

                    jQuery('.external-shell .external-site').html(hostname);
                    jQuery('#no_url_found').html('').hide();

                    if (meta_data.title || meta_data.description || meta_data.img) {
                        if (meta_data.title) {
                            jQuery('.external-shell .external-title').html('<strong>' + meta_data.title + '</strong>');
                        }

                        if (meta_data.description) {
                            jQuery('.external-shell .external-content').html(meta_data.description);
                        }

                        if (meta_data.img) {
                            jQuery('.external-shell .external_img').attr('src', meta_data.img);
                        }

                        jQuery('.external-shell').show();
                    }
                } catch (_) {
                    if (url != '') {
                        jQuery('#no_url_found').html("This is an invalid URL.").show();
                    } else {
                        jQuery('#no_url_found').html('').hide();
                    }

                    return false;
                }
            }
        });
    };
}

jQuery(document).ready(function ($) {
    CreatePostV2.init();
});
